module.exports = __webpack_public_path__ + "static/Logo-7b14c511b6f36142bf14eea32e92828c.svg";